import React from "react";
import DPCheckCard, { DPId, DPImageContainer } from "./DPCheckCard";
import useImageCheck from "../hooks/useImageCheck";
import styled from "styled-components";
import { DPImage } from "../styles/commonStyles";

const DPImageSlideCheck = ({
  uploadedImage,
  dpData,
  onChange,
  value,
  showCheckbox,
  disabled,
}) => {
  const { handleChange } = useImageCheck({
    onChange,
    value,
  });

  return (
    <DPCompareContainer>
      <DPImageContainer>
        <DPImage size="md" src={uploadedImage} />
        <DPId size="md">Uploaded photo</DPId>
      </DPImageContainer>
      <DPCheckCard
        id={dpData.fe_id}
        matchPercentage={dpData.match_score}
        image={dpData.profile_pic_url}
        changeOnCardClick
        onChange={(val) => handleChange(dpData.fe_id, val)}
        value={value?.includes(dpData.fe_id)}
        showCheckbox={showCheckbox}
        disabled={disabled}
        size="md"
      />
    </DPCompareContainer>
  );
};

export default DPImageSlideCheck;

export const DPCompareContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  width: max-content;
  padding: 0 20px;
`;
